import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AiGenerationPanelProps} from '@Panels/ai-generation-panel/ai-generation-panel.types';
import {AI_GENERATION_PANEL_ID} from '@Panels/ai-generation-panel/ai-generation-panel.types';

export type AiGenerationModalProps<T> = Omit<AiGenerationPanelProps<T>, 'panelId'>;

export const openAiGenerationModal = <T>(props: AiGenerationModalProps<T>): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_GENERATION_MODAL,
      panelProps: {
        ...props,
        panelId: AI_GENERATION_PANEL_ID,
      },
    })
  );
};
